if (!customElements.get('floating-button')) {
  customElements.define('floating-button', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal, passive: true };
      this.update = () => {
        const main = document.querySelector('#MainContent') || document.querySelector('main');
        const first = main && [...main.children].find(element => element.matches('.shopify-section') && !element.classList.contains('section-floating-button'));
        const footers = [...document.querySelectorAll('.shopify-section-group-footer-group, footer')];
        const visible = element => {
          const rect = element.getBoundingClientRect();
          return rect.height > 0 && rect.width > 0 && rect.bottom > 0 && rect.top < innerHeight;
        };
        // Never show above the first content section or while it remains on screen.
        const pastFirst = first && first.getBoundingClientRect().bottom <= 0;
        this.hidden = !pastFirst || footers.some(visible);
      };
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, options);
      window.addEventListener('resize', this.schedule, options);
      document.addEventListener('shopify:section:load', this.schedule, options);
      document.addEventListener('shopify:section:unload', this.schedule, options);
      document.addEventListener('shopify:section:reorder', this.schedule, options);
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.resizeObserver.observe(document.body);
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}
